"use client";

import MultiSelectCheckmarkBadgeIcon from "@homeinstead/icons/MultiSelectCheckmarkBadge";

type MultiSelectIndicatorProps = {
  isSelected: boolean;
};

/** A checkbox card's checkmark badge, or an empty box while unselected. */
function MultiSelectIndicator({ isSelected }: MultiSelectIndicatorProps) {
  return (
    <div className="w-6 shrink-0">
      {isSelected ? (
        <div
          aria-hidden="true"
          className="motion-safe:animate-multiselect-checkmark-enter motion-reduce:animate-none"
        >
          <MultiSelectCheckmarkBadgeIcon
            className="size-6 motion-safe:[&_path]:animate-selection-checkmark-draw motion-reduce:[&_path]:animate-none"
            data-testid="selected-multiselect-checkmark"
          />
        </div>
      ) : (
        <div
          aria-hidden="true"
          className="size-6 rounded-sm border-2 border-new-beginnings-base bg-white"
          data-testid="unchecked-selection-indicator"
        />
      )}
    </div>
  );
}

export { MultiSelectIndicator };
